import React from 'react';
import { SearchInput, Select, Button, DatePicker } from '@/components/ui';
import type { ScheduleFilters } from '../types/construction-schedules.types';

interface Props {
  filters: ScheduleFilters;
  onFilterChange: (filters: ScheduleFilters) => void;
  onAdd: () => void;
}

export const ScheduleToolbar: React.FC<Props> = ({ filters, onFilterChange, onAdd }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
      <div className="flex flex-1 gap-4 w-full md:w-auto overflow-x-auto pb-2 md:pb-0">
        <SearchInput
          placeholder="Mã lịch, công việc..."
          value={filters.search}
          onChange={(val) => onFilterChange({ ...filters, search: val })}
          className="min-w-[200px]"
        />
        <DatePicker
          placeholder="Lọc theo ngày"
          value={filters.date}
          onChange={(val) => onFilterChange({ ...filters, date: val })}
          className="min-w-[150px]"
        />
        <Select
          value={filters.status}
          onValueChange={(val) => onFilterChange({ ...filters, status: val as ScheduleFilters['status'] })}
          options={[
            { value: 'all', label: 'Mọi trạng thái' },
            { value: 'active', label: 'Đang triển khai' },
            { value: 'delayed', label: 'Trễ tiến độ' },
            { value: 'completed', label: 'Đã hoàn thành' },
          ]}
          className="min-w-[150px]"
        />
      </div>
      
      <div className="flex gap-2 w-full md:w-auto">
        <Button variant="outline" icon="ri-calendar-line">Chế độ Lịch</Button>
        <Button variant="primary" icon="ri-add-line" onClick={onAdd}>Thêm kế hoạch</Button>
      </div>
    </div>
  );
};
